<template>
    <div>
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="用户名：">
                    <el-input size="default" v-model.trim="formInline.username" maxlength="60" placeholder="请输入用户名" @change="search" clearable></el-input>
                </el-form-item>
                 <el-form-item label="IP：">
                    <el-input size="default" v-model.trim="formInline.ip" maxlength="60" placeholder="请输入IP" @change="search" clearable></el-input>
                </el-form-item>
                <el-form-item label="登录时间：">
                     <el-date-picker
                        v-model="formInline.create_time"
                        type="datetimerange"
                        @change="search"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" v-auth="'search'">查询</el-button>
                    <el-button @click="reset" v-auth="'reset'">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="table">
            <el-table :height="tableHeight" stripe :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
                <el-table-column type="index" width="60" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="username" label="用户名" align="center"></el-table-column>
                <el-table-column prop="ip" label="登录IP" align="center"></el-table-column>
                <el-table-column prop="agent" label="User-Agent" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="login_type" label="登录类型" align="center"></el-table-column>
                <el-table-column prop="create_time" label="登录时间" align="center" width="200" sortable></el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
    </div>
</template>
<script setup>
    import Pagination from "@/components/Pagination";
    import {getLoginLogList} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    import { ref, onMounted, computed, getCurrentInstance } from 'vue'

    const {proxy} = getCurrentInstance()
    let tableSelect = ref(null)
    let loadingPage = ref(false)
    let tableHeight = ref(400)
    let formInline = ref({
        page: 1,
        limit: 20,
        username: '',
        ip: '',
        create_time: '',
    })
    let pageparm = ref({
        page: 1,
        limit: 20,
        total: 0
    })
    let tableData = ref([])

    // 表格序列号
    const getIndex = ($index) => {
        // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
        return (pageparm.value.page-1)*pageparm.value.limit + $index +1
    }
    const callFather = (parm) => {
        formInline.value.page = parm.page
        formInline.value.limit = parm.limit
        getData()
    }

    const search = () => {
        formInline.value.page = 1
        formInline.value.limit = 20
        getData()
    }
    const reset = () => {
        formInline.value.page = 1
        formInline.value.limit = 20
        formInline.value.username = ''
        formInline.value.ip = ''
        formInline.value.create_time = ''
        getData()
    }

    //获取列表
    const getData = () => {
        let params = {
          username: formInline.value.username,
          ip: formInline.value.ip,
        }
        if(formInline.value.create_time) {
            params.beginAt = formInline.value.create_time[0]
            params.endAt = formInline.value.create_time[1]
        }
        loadingPage.value = true
        getLoginLogList(params, {page: formInline.value.page, limit: formInline.value.limit}).then(res => {
            loadingPage.value = false
            if(res.code === 2000) {
                tableData.value = res.data.data
                pageparm.value.page = res.data.page;
                pageparm.value.limit = res.data.limit;
                pageparm.value.total = res.data.total;
            }
        })
    }

    // 监听页面宽度变化搜索框的高度
    const listenResize = () => {
        proxy.$nextTick(() => {
            getTheTableHeight()
        })
    }
    const getTheTableHeight = ()=>{
        let tabSelectHeight = tableSelect.value?tableSelect.value.offsetHeight:0
        tableHeight.value =  getTableHeight(tabSelectHeight)
    }

    onMounted(()=>{
        getData();
        window.addEventListener('resize', listenResize);
        getTheTableHeight()
    })

</script> 